import React from 'react';

import NearMeIcon from '@mui/icons-material/NearMe';


const NearbyCard = ({ title, image,link}) => {
  return (
    
    <div className="nearby-card" >
      <div className="nearby-img" >
        <img style={{ width:"240px", height:"180px"}}  src={image} alt="" /></div>
      <div className="nearby-details">
        <h3 className="titlesFontFamily" style={{fontSize:"25px"}}>{title}</h3>
        {/* <a href={link} target='_blank'rel="noreferrer" style={{ padding: "6px 14px", cursor: "pointer", borderRadius: "15px", display: 'flex', alignItems: "center", textDecoration: 'none'  ,  width:"75px"}} className='btn'>Visit <NearMeIcon sx={{marginLeft:"3px",
        width:"18px"
        }}/></a> */}
<a href={link} target='_blank'rel="noreferrer" className='visitbutton' >
  <div className="svg-wrapper-1">
    <div className="svg-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
      >
        <path fill="none" d="M0 0h24v24H0z"></path>
        <path
          fill="currentColor"
          d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"
        ></path>
      </svg>
    </div>
  </div>
  <span>Visit</span>
</a>


      </div>
    </div>
   
  );
}; 



export default NearbyCard;
